module.exports = __webpack_public_path__ + "img/risk-approve.54c6f65c.png";